import { render, staticRenderFns } from "./AlignHorizontal.vue?vue&type=template&id=74de07eb&scoped=true"
import script from "./AlignHorizontal.vue?vue&type=script&lang=js"
export * from "./AlignHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74de07eb",
  null
  
)

export default component.exports